export default __webpack_public_path__ + "static/media/ev-banner.85f8b883.png";